import api from '@/api'

const namespaced = true

const state = {
  monitoringReports: [],
  monitoringReportFile: null,
  companies: [],
  tugsNames: []
}

const getters = {
  monitoringReports: state => state.monitoringReports,
  monitoringReportFile: state => state.monitoringReportFile,
  companies: state => state.companies,
  tugsNames: state => state.tugsNames
}

const mutations = {
  SET_MONITORING_REPORTS: (state, payload) => {
    state.monitoringReports = payload
  },
  SET_MONITORING_REPORT_FILE: (state, payload) => {
    state.monitoringReportFile = payload
  },
  SET_COMPANIES: (state, payload) => {
    state.companies = payload
  },
  SET_TUG_NAMES: (state, payload) => {
    state.tugsNames = payload
  }
}

const actions = {
  async fetchCompanies({ commit }) {
    try {
      const { data } = await api.getCompanies()
      if (data.error) {
        commit('SET_COMPANIES', [])
        return
      }

      commit('SET_COMPANIES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchTugNames({ commit }, payload) {
    try {
      const { data } = await api.getTugsNames(payload)
      if (data.error) {
        commit('SET_TUG_NAMES', [])
        return
      }

      commit('SET_TUG_NAMES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchMonitoringReports({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        ...payload,
        tug_name_search: filterConfig.search ? filterConfig.search : null,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize
      }

      const { data } = await api.getMonitoringReport(filter)

      if (data.error) {
        commit('SET_MONITORING_REPORTS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_MONITORING_REPORTS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async downloadMonitoringReports({ commit }, payload) {
    try {
      const filter = { ...payload }
      const response = await api.downloadMonitoringReport(filter)

      if (response.data.error) {
        commit('SET_MONITORING_REPORT_FILE', null)
        return
      }

      commit('SET_MONITORING_REPORT_FILE', response)
    } catch (err) {
      throw err
    }
  },
  resetFile({ commit }) {
    commit('SET_MONITORING_REPORT_FILE', null)
  }
}

export default { namespaced, state, getters, mutations, actions }
